





























import { AchievementType } from '@/models';
import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'DeleteAchievementModal',
  props: {
    achievement: Object as () => AchievementType,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        id: '',
        name: '',
        imageUrl: '',
      },
    };
  },
  methods: {
    async deleteAchievement() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.achievements.deleteAchievement, this.achievement.id);
        ToastsService.success(this.$t('admin-panel.achievements.tabs.types.achievement-deleted-toast') as string);
        this.$bvModal.hide('delete-achievement-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async setAchievement() {
      this.form = {
        id: this.achievement.id,
        name: this.achievement.name,
        imageUrl: this.achievement.imageUrl,
      };
    },
  },
});
